import type { WorkspaceSummary } from "../../lib/api";

export type WorkspaceMode = "admin" | "provider";

const fallbackWorkspaceContent: Record<WorkspaceMode, WorkspaceSummary> = {
  admin: {
    eyebrow: "Admin command",
    title: "Business-wide control plane",
    description:
      "This is the new admin landing zone. It exists to validate that the reset stack can protect the highest-risk workflows before feature migration starts.",
    checklist: [
      "Centralize support, moderation, and operator tooling behind one login surface.",
      "Kill duplicated provider/admin shell logic before business users validate migrated screens.",
      "Promote only validated features into this shell; leave the legacy apps untouched until cutover.",
    ],
  },
  provider: {
    eyebrow: "Provider operations",
    title: "Venue-side workspace",
    description:
      "This is the first provider landing zone in the reset stack. It proves the new auth boundary and gives us a clean target for bookings, venues, and staff workflows.",
    checklist: [
      "Role-gated access is handled by the new backend instead of implicit legacy relationships.",
      "Provider-facing features can now migrate in small slices without re-litigating shell decisions.",
      "Business validation can happen here before any full cutover to the new platform.",
    ],
  },
};

export function getFallbackWorkspaceSummary(mode: WorkspaceMode) {
  return fallbackWorkspaceContent[mode];
}